function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import commonProps, { omitCommonProps } from "./_commonProps";

var ComputedField = function ComputedField(_ref) {
  var label = _ref.label,
      value = _ref.value,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["label", "value", "children"]);

  return React.createElement(
    "div",
    omitCommonProps(props),
    React.createElement(
      "label",
      null,
      label
    ),
    React.createElement(
      "div",
      { className: "content" },
      value || children
    )
  );
};

var StyledComputedField = styled(ComputedField).withConfig({
  displayName: "ComputedField__StyledComputedField",
  componentId: "sc-1495jej-0"
})(["display:", ";margin-bottom:1em;&:not(:last-child){margin-right:0.5em;}.content{padding:0.5em;background:repeating-linear-gradient( -10deg,transparent,transparent 3px,#f4f4f4 3px,#f4f4f4 6px );font-size:2em;line-height:1em;color:", ";font-weight:800;", ";}"], function (props) {
  return props.fluid ? "block" : "inline-block";
}, function (props) {
  return props.theme.secondary;
}, commonProps);

StyledComputedField.propTypes = {
  fluid: PropTypes.bool
};

StyledComputedField.defaultProps = {
  fluid: false
};

export default StyledComputedField;